import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  auth, 
  googleProvider, 
  githubProvider, 
  signInWithPopup,
} from '../../firebase/firebase';
import './Login.css';
import { Typography } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';

const GoogleIconColored = () => (
  <svg width="20px" height="20px" viewBox="0 0 48 48" className="icon" style={{ marginRight: '0.5rem' }}>
    <path fill="#4285F4" d="M24 9.5c3.13 0 5.9 1.12 7.97 3.03l6.2-6.2C34.21 2.52 29.5 0 24 0 14.52 0 6.44 5.27 3.18 12.84l7.65 5.9C12.33 13.53 17.69 9.5 24 9.5z"></path>
    <path fill="#34A853" d="M46.82 24.54c0-1.66-.15-3.26-.42-4.82H24v9.09h12.8c-.55 3.03-2.16 5.6-4.59 7.39l7.32 5.68C43.5 38.31 46.82 31.99 46.82 24.54z"></path>
    <path fill="#FBBC05" d="M10.83 28.74c-.58-1.74-.91-3.58-.91-5.48s.33-3.74.91-5.48l-7.65-5.9C1.15 15.19 0 19.49 0 24s1.15 8.81 3.18 12.16l7.65-5.9z"></path>
    <path fill="#EA4335" d="M24 48c5.5 0 10.19-1.82 13.59-4.91l-7.32-5.68c-1.83 1.23-4.18 1.96-6.27 1.96-6.31 0-11.67-4.03-13.59-9.52l-7.65 5.9C6.44 42.73 14.52 48 24 48z"></path>
    <path fill="none" d="M0 0h48v48H0z"></path>
  </svg>
);

const Login = () => {
  const navigate = useNavigate();

  const handleGoogleSignUp = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      window.gtag('event', 'google-signup');
      navigate('/playground');
    } catch (error) {
      console.error("Error signing up with Google:", error);
    }
  };

  const handleGithubSignUp = async () => {
    try {
      await signInWithPopup(auth, githubProvider);
      window.gtag('event', 'github-signup');
      navigate('/playground');
    } catch (error) {
      console.error("Error signing up with Github:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-section">
        <div className="login-form-container">
          <div className="login-header">
            {/* You can replace this with your logo */}
            <div className="logo"></div>
            <Typography variant="h4" component="h1" gutterBottom>Welcome to A1Facts.ai</Typography>
          </div>
          <button className="social-login-btn" onClick={handleGoogleSignUp}>
            <GoogleIconColored />
            Continue with Google
          </button>
          <button className="social-login-btn" onClick={handleGithubSignUp}>
            <GitHubIcon className="icon" />
            Continue with Github
          </button>
          <p className="privacy-policy">
            By creating an account, you agree to our{' '}
            <a href="/privacy">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
      <div className="info-section">
        <div className="info-section-spacer" />
        <Typography variant="h4" component="h2">
          A Reliable Source of Truth
        </Typography>
        <ul>
          <li>
            <span className="tick-icon">✔</span>
            <Typography variant="body1">
              <strong>Stop AI Hallucinations:</strong> Ensure your AI provides factual, verifiable answers you can trust.
            </Typography>
          </li>
          <li>
            <span className="tick-icon">✔</span>
            <Typography variant="body1">
              <strong>Enable High-Stakes Decisions:</strong> Build AI applications for critical use cases in finance, healthcare, and legal.
            </Typography>
          </li>
          <li>
            <span className="tick-icon">✔</span>
            <Typography variant="body1">
              <strong>Maintain a Source of Truth:</strong> Connect your AI to a reliable, auditable knowledge base.
            </Typography>
          </li>
          <li>
            <span className="tick-icon">✔</span>
            <Typography variant="body1"><strong>Deploy with Confidence:</strong> Integrate a precision layer into your AI stack in minutes.</Typography>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Login;
